
/**
 * 
 */
export namespace ChooseCardKind {

    export enum GeneralValue {
        /** 奖金 */
        AWARD_NUM = 10000000,
    }
    
    /** 牌型 */
    export enum CardType {
       /** 清七对 */
       QING_QI_DUI, 
       /** 碰清 */
       PENG_QING, 
       /** 十三幺 */
       SHI_SAN_YAO, 
    }

    /** 牌型信息 */
    class CardTypeInfo {
        /** 名称 */
        name: string = '';
        /** 颜色 */
        color: cc.Color = null;
    }

    /** 牌型数据 */
    export class CardTypeData {
        /** 牌 */
        card: number[] = [];
        /** 能胡的牌 */
        winCard: number[] = [];
    }

}

